import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useNavigate } from '@aviv-unified-frontend/runtime/router';
import { Box } from '@gemini/core';
import { appendEphemeralParam } from '@/helpers/ephemeral/ephemeral';
import { useAddMediumQueryParam } from '@/hooks/useAddMediumQueryParams/useAddMediumQueryParam';
export const Link = ({ href, children, mediumAttribute, isExternal, title }) => {
    const linkRef = useRef(null);
    const { hrefWithMedium } = useAddMediumQueryParam(href, mediumAttribute, linkRef);
    const finalHref = isExternal ? hrefWithMedium : appendEphemeralParam(hrefWithMedium);
    const navigate = useNavigate();
    const handleClick = (event) => {
        if (isExternal) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        navigate(finalHref);
    };
    return (_jsx(Box, { as: "a", href: finalHref, onClick: handleClick, color: "unsafe_component.link.color.default.default", ref: linkRef, title: title, children: children }));
};
